import styled from 'styled-components'

import { trackingPageGridGaps } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  .react-grid-item {
    cursor: grab;
  }

  .react-grid-item.react-draggable-dragging {
    cursor: grabbing;
  }

  .react-grid-item.react-grid-placeholder {
    background: transparent;
    opacity: 1;
  }

  .react-grid-item.react-grid-placeholder::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    border-radius: 2px;
    background-color: ${props => props.theme.colors.outline.default};
  }

  .react-grid-item.react-grid-placeholder.placeholder-resizing::before {
    display: none;
  }

  .react-grid-item > .react-resizable-handle.react-resizable-handle-w,
  .react-grid-item > .react-resizable-handle.react-resizable-handle-e {
    width: ${props => props.theme.spacing.sp24};
    height: 100%;
    top: 0;
    margin-top: 0;
    transform: none;
  }

  .react-grid-item > .react-resizable-handle.react-resizable-handle-w {
    left: -${props => props.theme.spacing.sp24};
  }

  .react-grid-item > .react-resizable-handle.react-resizable-handle-e {
    right: -${props => props.theme.spacing.sp24};
  }

  .react-grid-item > .react-resizable-handle.react-resizable-handle-s,
  .react-grid-item > .react-resizable-handle.react-resizable-handle-sw,
  .react-grid-item > .react-resizable-handle.react-resizable-handle-se {
    bottom: 0;
    height: ${props => trackingPageGridGaps[props.viewMode]}px;
    transform: none;
  }

  .react-grid-item > .react-resizable-handle.react-resizable-handle-s {
    left: 0;
    width: 100%;
    margin-left: 0;
  }

  .react-grid-item > .react-resizable-handle.react-resizable-handle-sw,
  .react-grid-item > .react-resizable-handle.react-resizable-handle-se {
    width: ${props => props.theme.spacing.sp24};
  }

  .react-grid-item > .react-resizable-handle.react-resizable-handle-sw {
    left: -${props => props.theme.spacing.sp24};
  }

  .react-grid-item > .react-resizable-handle.react-resizable-handle-se {
    right: -${props => props.theme.spacing.sp24};
  }

  .react-grid-item > .react-resizable-handle::after {
    display: none;
  }
`
